import React, { useState } from 'react';
import { Menu } from 'antd';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Actions } from '../../store/actions';
import BrandLogo from '../BrandLogo';
import Navigation from '../../navigation/Navigation';

function Sidebar({ role, hide, user, activeSidebarKey, updateSidebarTab, ...props }) {
	const history = useHistory();
	const links = Navigation.getSidebarLinks(role);

	return (
		<div className="sidebar-container">
			<div className="sidebar-content">
				<Menu theme="dark" mode="inline" selectedKeys={[activeSidebarKey]}>
					{links.map(
						(item, index) =>
							item.role.includes(user?.role) && (
								<Menu.Item key={index} onClick={() => updateSidebarTab(`${index}`)}>
									<Link to={item.path} onClick={hide}>
										<span className="icon">{item.icon ? item.icon() : null}</span>
										<span>{item.name}</span>
									</Link>
								</Menu.Item>
							)
					)}
				</Menu>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	role: state.session.role,
	user: state.session.user,
	activeSidebarKey: state.activeTabKey.activeSidebarKey,
});

const mapDispatchToProps = (dispatch) => ({
	updateSidebarTab: (key) => dispatch(Actions.updateSidebarTab(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
